import type { EntryIconColorId } from '@trove/core';
import { ENTRY_ICON_COLOR_IDS } from '@trove/core';

export const ENTRY_ICON_COLOR_OPTIONS: Array<{
  id: EntryIconColorId;
  label: string;
  hex: string;
}> = [
  { id: 'slate', label: 'Slate', hex: '#4d6478' },
  { id: 'jade', label: 'Jade', hex: '#0f766e' },
  { id: 'sky', label: 'Sky', hex: '#3b6d8f' },
  { id: 'violet', label: 'Violet', hex: '#6b5b95' },
  { id: 'amber', label: 'Amber', hex: '#8a6a22' },
  { id: 'rose', label: 'Rose', hex: '#9a4d3d' },
  { id: 'forest', label: 'Forest', hex: '#2f6b4f' },
  { id: 'orange', label: 'Orange', hex: '#b45309' },
];

export function entryIconColorHex(id: EntryIconColorId | undefined): string | undefined {
  if (!id || !(ENTRY_ICON_COLOR_IDS as readonly string[]).includes(id)) return undefined;
  return ENTRY_ICON_COLOR_OPTIONS.find((entry) => entry.id === id)?.hex;
}
